/* eslint-disable react/prop-types */
import React from 'react';
import _ from 'lodash';
import MuiTextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import DoneIcon from '@mui/icons-material/Done';
import { singleFunctionAsyncCache } from 'relevant-shared/misc/misc';
import ExternalSystemEdit from '../components/ExternalSystemEdit';
import { PopupForm } from '../components/Wrappers';
import AutocompleteInput from '../components/AutocompleteInput';

const LIST_AD_UNIT_MS = 30 * 60 * 1000;

const topLevelCache = singleFunctionAsyncCache((system) => ({
	key: system.id,
	fn: () => system.getTopLevelAdUnits(),
}), { timeoutMs: LIST_AD_UNIT_MS });

const getFullAdUnitList = (adUnits, selected) => [
	..._.difference(selected, _.map(adUnits, 'id')).map((id) => ({
		id, name: `[UNKNOWN id: ${id}]`, isUnknown: true,
	})),
	...adUnits,
];

ExternalSystemEdit.registerCustomRenderer('GamAdUnitFilter', ({ system, sysProps: { form } }) => (
	<PopupForm
		selected={system.adUnitFilter}
		title="Filtered top level ad units"
		size="sm"
		getModel={() => _.cloneDeep(system.adUnitFilter)}
		fn={() => topLevelCache(system)}
		content={({ opResult: initList, model: adUnitFilter, popup }) => {
			const fullList = getFullAdUnitList(initList, adUnitFilter);
			return (
				<AutocompleteInput
					suggestions={fullList}
					onChange={(opts) => popup.update(() => {
						adUnitFilter.length = 0;
						adUnitFilter.push(..._.map(opts, 'id'));
					})}
					value={adUnitFilter.map((id) => ({ id, name: _.find(fullList, { id })?.name || id }))}
					autocompleteProps={{
						multiple: true,
						renderInput: (params) => (
							<MuiTextField {...params} label="Top level ad units" />
						),
						renderOption: (subProps, option, { selected: isSelected }) => (
							<Box {...subProps}>
								<div>
									<div>{option.name}</div>
								</div>
								<div>
									{ isSelected && <DoneIcon /> }
								</div>
							</Box>
						),
						isOptionEqualToValue: (option, value) => (option.id === value.id),
						getOptionLabel: (option) => option.name,
					}}
				/>
			);
		}}
		onApplyChanges={({ model: adUnitFilter }) => form.setVals({ adUnitFilter })}
	/>
));
